import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { apiProcess } from 'app/config/axios-interceptor';
import { createEntitySlice, serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState: any = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: {},
  otherComment:[],
  viewing: false,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/evaluates';

type IRequest = {
  userId: string;
  ownerId: string;
  planPeriodId: string;
};

export const getSelfConfirmComplete = createAsyncThunk(
  'self_confirm_complete/finish_evaluate',
  async ({ userId, ownerId , planPeriodId}: IRequest) => {
    return apiProcess.get<any[]>(`${apiUrl}/finish-evaluate/self`, {
      params: {
        userId,
        ownerId,
        planPeriodId,
        cacheBuster: new Date().getTime(),
      },
    });
  },
  { serializeError: serializeAxiosError },
);

export const saveDraft = createAsyncThunk(
  'self_confirm_complete/save_draft',
  async (payload: any) => {
    return apiProcess.post<any>(`${apiUrl}/finish-evaluate/self/confirm`, payload);
  },
  { serializeError: serializeAxiosError },
);

export const confirmComplete = createAsyncThunk(
  'self_confirm_complete/finish',
  async (payload: any) => {
    return apiProcess.post<any>(`${apiUrl}/submit-evaluate`, payload);
  },
  { serializeError: serializeAxiosError },
);

export const getOtherPlusComment = createAsyncThunk(
  'check_confirm_complete/get_other_plus_comment',
  async ({ index, documentId, ownerId, evaluateLevelId, planPeriodId }: any) => {
    return apiProcess.get<any>(`${apiUrl}/other-level-pluspoint`, {
      params: { index, documentId, ownerId, evaluateLevelId, planPeriodId },
    });
  },
  { serializeError: serializeAxiosError },
);

export const getOtherMinusComment = createAsyncThunk(
  'check_confirm_complete/get_other_minus_comment',
  async ({ index, documentId, ownerId, evaluateLevelId, planPeriodId }: any) => {
    return apiProcess.get<any>(`${apiUrl}/other-level-minuspoint`, {
      params: { index, documentId, ownerId, evaluateLevelId, planPeriodId },
    });
  },
  { serializeError: serializeAxiosError },
);

export const getOtherComment = createAsyncThunk(
  'check_confirm_complete/get_other_comment',
  async ({ documentId, ownerId, evaluateLevelId, planPeriodId }: any) => {
    return apiProcess.get<any>(`${apiUrl}/other-level-generalfeedback`, {
      params: { documentId, ownerId, evaluateLevelId, planPeriodId },
    });
  },
  { serializeError: serializeAxiosError },
);


// slice

export const SelfConfirmCompleteEvaluationSlice = createEntitySlice({
  name: 'selfConfirmCompleteEvaluation',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getSelfConfirmComplete), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          loading: false,
          entities: data,
        };
      })
      .addMatcher(isFulfilled(getOtherPlusComment), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          otherComment: data,
        };
      })
      .addMatcher(isFulfilled(getOtherComment), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          otherComment: data,
        };
      })
      .addMatcher(isFulfilled(getOtherMinusComment), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          otherComment: data,
        };
      })
      .addMatcher(isFulfilled(confirmComplete), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
      })
      .addMatcher(isFulfilled(saveDraft), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
      })
      .addMatcher(isPending(saveDraft, confirmComplete), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      })
      .addMatcher(isPending(getOtherPlusComment, getOtherComment, getOtherMinusComment), (state:any) => {
        state.otherComment = [];
      })
      .addMatcher(isPending(getSelfConfirmComplete), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
        state.entities = [];
      });
  },
});

export const { reset } = SelfConfirmCompleteEvaluationSlice.actions;

// Reducer
export default SelfConfirmCompleteEvaluationSlice.reducer;
